import { ApiResponse, ZillowPriceZipCode, ZillowRentZipCode, ZipCode } from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getZillowPriceByZipCode = async (zipCode: ZipCode, from: Date) => {
  const response = await api.get<ApiResponse<ZillowPriceZipCode[]>>(
    `/zillow/price/zip-code/${zipCode}?from=${from.toISOString().split('T')[0]}`
  );

  return unwrapApiResponse(response.data);
};

export const getZillowRentByZipCode = async (zipCode: ZipCode, from: Date) => {
  const response = await api.get<ApiResponse<ZillowRentZipCode[]>>(
    `/zillow/rent/zip-code/${zipCode}?from=${from.toISOString().split('T')[0]}`
  );

  return unwrapApiResponse(response.data);
};
